import { Fetch } from './Fetch';

export interface IHistoryValues {
	Last7Days: number;
	Last30Days: number;
	Last90Days: number;
	Last365Days:number;
}

export interface IDashboardOverview {
	Registrations: IHistoryValues | null;
	Trials: IHistoryValues | null;
	ActiveTrials: number;
}

export const Dashboard = {
	getOverview: (): Promise<IDashboardOverview> =>
		Fetch.get(`/management/dashboard/overview`),
}